import React, { Dispatch, Fragment } from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import { NonLinearStepType } from '../NonLinearStepper';
import * as S from './NonLinearStep.styles';

interface NonLinearStepProps {
  index: number;
  step: NonLinearStepType;
  activeIndex?: number;
  iconSize: number;
  shouldHighlightStep: boolean;
  shouldHighlightConnector: boolean;
  indexErrorMap: Record<number, boolean>;
  setIndexErrorMap: Dispatch<
    React.SetStateAction<{
      [key: number]: boolean;
    }>
  >;
}

export const NonLinearStep = ({
  index,
  activeIndex,
  step,
  iconSize,
  shouldHighlightConnector,
  shouldHighlightStep,
  indexErrorMap,
  setIndexErrorMap,
}: NonLinearStepProps) => {
  const { hoverLabel, logoUrl, imgNode, connectorLabel, iconColor } = step;
  const isActiveStep = index === activeIndex;

  return (
    <Fragment key={index}>
      <TooltipContainer label={hoverLabel} placement="top">
        <S.StepContainer
          $active={shouldHighlightStep}
          aria-current={isActiveStep ? 'step' : undefined}
          data-testid={`step-${hoverLabel}`}
        >
          {imgNode ? (
            <S.CustomLogo $size={iconSize}>{imgNode}</S.CustomLogo>
          ) : indexErrorMap[index] || !logoUrl ? (
            <S.FallbackLogo
              data-testid={`fallback-logo-${hoverLabel}`}
              $size={iconSize}
              $active={shouldHighlightStep}
            >
              {hoverLabel.charAt(0).toUpperCase()}
            </S.FallbackLogo>
          ) : (
            <S.StepLogo
              data-testid={`logo-${hoverLabel}`}
              key={index}
              onError={() =>
                setIndexErrorMap(prev => ({ ...prev, [index]: true }))
              }
              src={logoUrl}
              alt={hoverLabel}
              width={iconSize}
              height={iconSize}
              $size={iconSize}
              $color={iconColor}
            />
          )}
        </S.StepContainer>
      </TooltipContainer>
      {connectorLabel && (
        <>
          <S.DottedLine $active={shouldHighlightConnector} />
          <S.Connector $active={shouldHighlightConnector}>
            {connectorLabel}
          </S.Connector>
          <S.DottedLine $active={shouldHighlightConnector} />
        </>
      )}
    </Fragment>
  );
};

NonLinearStep.Styled = S;
